module.exports = __webpack_public_path__ + "img/isola.d0b80ea4.png";